import { Header } from "../component/home/Header";
import { Footer } from "../component/home/Footer";
// import { ChatbotWidget } from "../component/home/ChatbotWidget";
import { Hero } from "../component/how-it-works/Hero";
import { ProcessSteps } from "../component/how-it-works/ProcessSteps";
import { Eligibility } from "../component/how-it-works/Eligibility";
import { DataSafety } from "../component/how-it-works/DataSafety";

export function HowItWorksPage() {
  return (
    <div className="min-h-screen w-full bg-white">
      <Header />

      <main>
        <Hero />
        <ProcessSteps />
        <Eligibility />
        <DataSafety />
      </main>

      <Footer />
      {/* <ChatbotWidget /> */}
    </div>
  );
}
